var map = {
	"./BardClass.jpg": 8281,
	"./CampaignRules1.jpg": 8132,
	"./CampaignRules2.jpg": 4054,
	"./ClassRequirements.jpg": 1970,
	"./ClassXPTables.jpg": 6119,
	"./CombatActions.jpg": 7346,
	"./CombatCheatSheet.jpg": 2272,
	"./CriticalHits.jpg": 4118,
	"./FumbleTable.jpg": 570,
	"./Potions00.jpg": 9768,
	"./SavingThrows.jpg": 1833,
	"./ScrollFailure.jpg": 7430,
	"./SpellsByLevel.jpg": 9217,
	"./ThiefSkills.jpg": 5939,
	"./ToHit.jpg": 2677,
	"./ToHitAndCrit.jpg": 3426,
	"./TurnUndead.jpg": 8625,
	"./items/Armor.jpg": 9533,
	"./items/Armor.pdf": 5819,
	"./items/Bows.jpg": 3790,
	"./items/Potions.jpg": 8004,
	"./items/Weapons.jpg": 5603,
	"./items/Weapons.pdf": 31,
	"./magicItems/All Magic Items.pdf": 1687,
	"./magicItems/AllMagicItems.pdf": 9479,
	"./magicItems/Armor and Weapons.pdf": 1118,
	"./magicItems/Artifacts.pdf": 7203,
	"./magicItems/Magic Items Table.pdf": 6230,
	"./magicItems/Magic Rings.pdf": 1625,
	"./magicItems/MagicItemsTable.pdf": 721,
	"./magicItems/Miscellaneous Magic.pdf": 2323,
	"./magicItems/Potions.pdf": 7376,
	"./magicItems/Rods Staffs Wands.pdf": 4371,
	"./magicItems/Scrolls.pdf": 1656,
	"./pdf2img.py": 361,
	"./spells/Spell-Tables.pdf": 580,
	"./spells/Spells-Cleric.pdf": 5080,
	"./spells/Spells-Druid.pdf": 4794,
	"./spells/Spells-Illusionist.pdf": 1608,
	"./spells/Spells-MagicUser.pdf": 8292,
	"./tables/Saving Throws Orig.pdf": 5535,
	"./tables/Saving Throws.7da7b3de6d48807c12dd.pdf": 6150,
	"./tables/Saving Throws.pdf": 1809,
	"./tables/Weapons.txt": 7213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7813;